import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
  namespaced: true,
  state: {
    aggregate: {},
    customers: [],
    sales: [],
    earnings: {
      year: [],
      month: [],
      week: [],
    },
    orders: [],
    products_uploads: [],
    sales_location: [],
    products_sales: [],
    geo_coded_sales_location: [
      ['lat', 'lng', 'Address', 'Sales', 'Amount'],
    ],
    top_states: [],
    top_regions: [],
  },
  mutations,
  actions,
  getters,
};
